/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

export const subscriptionAccessDataReason = {
	subscribed: 'subscribed',
	'parent-subscribed': 'parent-subscribed',
	demo: 'demo',
	'external-invoicing': 'external-invoicing',
	'fully-serviced': 'fully-serviced',
	exempt: 'exempt',
	'jobilla-staff': 'jobilla-staff',
	'subscription-inactive': 'subscription-inactive',
	'no-subscription': 'no-subscription',
} as const

export type SubscriptionAccessDataReason =
	(typeof subscriptionAccessDataReason)[keyof typeof subscriptionAccessDataReason]
